import { type FC } from "react";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "../types/props";
import { getAssessmentFilters } from "./assessmentFilters";
import { type AssessmentFiltersEnum } from "../../../features/Library/Assessments/types/state";

export interface AssessmentFilterFormProps extends FilterFormPropsBase<AssessmentFiltersEnum> {}

const AssessmentFilterForm: FC<AssessmentFilterFormProps> = ({
  filterOptions,
  filter,
  onValidationChange,
  updateFilter,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getAssessmentFilters()}
    onValidationChange={onValidationChange}
  />
);

export default AssessmentFilterForm;
